<template>
  <div class="message-char-counter">
    <slot v-if="mode === 1">
      <p>
        <b>{{ text.length }}</b> Zeichen:

        <span v-if="text.length < 161">Gratis</span>
        <span v-if="text.length > 160 && text.length < 321">
          <slot v-if="$store.getters.isB2b">
            {{ splittedTaxSingleNet(2.0) }} zzgl. MwSt.
          </slot>

          <slot v-else>
            {{ splittedTaxSingle(2.0) }} inkl. MwSt.
          </slot>
        </span>
        <span v-if="text.length > 321 && text.length < 481">
          <slot v-if="$store.getters.isB2b">
            {{ splittedTaxSingleNet(4.0) }} zzgl. MwSt.
          </slot>

          <slot v-else>
            {{ splittedTaxSingle(4.0) }} € inkl. MwSt.
          </slot>
        </span>

        <IconTooltip>160 Zeichen handgeschriebener Grußtext sind im Preis inbegriffen. Je weitere 160 Zeichen zzgl. 2,00 EUR netto, maximal 480 Zeichen möglich.</IconTooltip>
      </p>

      <div class="message-char-counter__bar">
        <span class="message-char-counter__progress" :style="`width: ${text.length / 480 * 100}%`"></span>
      </div>
    </slot>

    <slot v-if="mode === 2">
      <p>
        <b>{{ text.length }}</b> Zeichen: Gratis
      </p>

      <div class="message-char-counter__bar">
        <span class="message-char-counter__progress" :style="`width: ${text.length / 1200 * 100}%`"></span>
      </div>
    </slot>
  </div>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';

import IconTooltip from '@/components/Common/IconTooltip';

export default {
  name: 'MessageCharCounter',
  mixins: [logicMixin],
  components: {
    IconTooltip,
  },
  props: {
    // It refers to the composer's object key: modules.postcard.message.mode
    mode: {
      type: Number
    },
    text: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Message Char Counter
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Postcard message character counter
 * @since 2022-09-06
**/

$component: 'message-char-counter';

.#{$component} {
  @include margin-top(- map-get($spacers, 2));
  @include margin-bottom($spacer);
  color: $ink-lighter;
  @include font-size($font-size-sm);

  > p {
    margin: 0;
  }

  &__chars {
    @include margin-top(- map-get($spacers, 2));
    @include margin-bottom($spacer);
    color: $ink-lighter;
    @include font-size($font-size-sm);

    > p {
      margin: 0;
    }
  }

  &__bar {
    width: 100%;
    overflow: hidden;
    @include margin-top(map-get($spacers, 2));
    border-radius: $border-radius-lg;
    background-color: $sky;
  }

  &__progress {
    display: block;
    min-width: 0.2px;
    height: 0.6rem;
    border-radius: $border-radius-lg;
    background-color: $primary;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
